<template>
  <b-container class="mw-100 mt-3">
    <b-card class="mt-4 mb-4" v-if="motivationSent">
      <b-container>
        <b-row>
          <b-col cols="12" sm="12" md="12" lg="8" xl="8">
            <b-container>
              <b-row>
                <b-col cols="12" sm="12" md="12" lg="12" xl="12" class="m-0 p-0">
                  <b-form-group label-for="input-vehicle" :label="`${$tc('message.vehicle', 1)}`">
                    <model-list-select id="input-vehicle"
                                       option-text="text"
                                       option-value="id"
                                       :customText="getVehicleOption"
                                       :placeholder="originalVehicles && originalVehicles.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="vehicleSelected"
                                       :list="originalVehicles">
                    </model-list-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" sm="12" md="12" lg="6" xl="6" class="m-0 p-0 pr-lg-2 pr-md-0">
                  <b-form-group :label="`${$tc('message.date', 1)} ${$tc('message.start', 1).toLowerCase()}`"
                                label-for="filter-start">
                    <b-input-group>
                      <flat-pickr :config="startFilterConfig"
                                  :placeholder="`${$tc('message.example', 1)}: ${DateTime.local().toFormat($t('message.dateFormat'))}`"
                                  :readonly="false"
                                  class="form-control"
                                  id="filter-start"
                                  v-model="startFilter">
                      </flat-pickr>

                      <div class="input-group-append">
                        <b-button :disabled="!startFilter"
                                  @click="resetStart">
                          <font-awesome-icon icon="trash"/>
                        </b-button>
                      </div>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="12" md="12" lg="6" xl="6" class="m-0 p-0 pl-lg-2 pl-md-0">
                  <b-form-group :label="`${$tc('message.hour', 1)} ${$tc('message.start', 1).toLowerCase()}`"
                                label-for="filter-start-hour">
                    <b-input-group>
                      <flat-pickr :config="startHourFilterConfig"
                                  :placeholder="`${$tc('message.example', 1)}: ${DateTime.local().hour}:${DateTime.local().minute}`"
                                  :readonly="false"
                                  class="form-control"
                                  id="filter-start-hour"
                                  :disabled="!startFilter"
                                  v-model="startHourFilter">
                      </flat-pickr>

                      <div class="input-group-append">
                        <b-button :disabled="!startHourFilter"
                                  @click="resetStartHour">
                          <font-awesome-icon icon="trash"/>
                        </b-button>
                      </div>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-container>
          </b-col>

          <b-col>
            <b-form-group :label="`${$tc('message.range', 1)} ${$tc('message.hour', 2).toLocaleLowerCase()}`">
              <b-form-radio v-model="hourRange" name="some-radios" value="6">6</b-form-radio>
              <b-form-radio v-model="hourRange" name="some-radios" value="12">12</b-form-radio>
              <b-form-radio v-model="hourRange" name="some-radios" value="24">24</b-form-radio>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row align-v="center" align-h="center">
          <b-col cols="2">
            <b-button v-on:click="searchPositions" class="b-c-green mt-2 mb-3">
              {{$tc('message.search', 1)}}
            </b-button>
          </b-col>
        </b-row>
      </b-container>

      <b-container v-show="searchValid">
        <b-row>
          <b-col>
            <h4 class="c-green mb-0 pb-2 mt-2">{{ $tc('message.details', 1) }}</h4>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6" class="mb-2" v-if="reportMain.start">
            <h5 class="c-green mb-0 pb-0">{{ $tc('message.start', 1) }}</h5> {{ reportMain.start }}
          </b-col>

          <b-col cols="6" class="mb-2" v-if="reportMain.end">
            <h5 class="c-green mb-0 pb-0">{{ $tc('message.end', 1) }}</h5> {{ reportMain.end }}
          </b-col>

          <b-col cols="6" v-for="(stat, index) in reportDetails" class="mb-2" :key="index">
            <h5 class="c-green mb-0 pb-0">{{ stat.key }}</h5> {{ stat.value }}
          </b-col>
        </b-row>
      </b-container>

      <b-container class="mt-3" v-show="searchValid">
        <b-row align-h="center">
          <b-col>
            <b-card class="mt-4 mb-4 mw-100">
              <h4 class="c-green mb-0 pb-2 mt-2">{{ $tc('message.travel', 1) }}</h4>
              <standard-table ref="vehicleTable"
                              :items="reportStops"
                              :fields="reportStopsFields"

                              :row-search="{cols: 12,sm: 12,md: 12,lg: 12,xl: 12}"

                              :row-pagination="{cols: 12, sm: 12, md: 7, lg: 5, xl: 5}"
                              :row-between-pagination="{cols: 12, sm: 12, md: 1, lg: 1, xl: 1}"
                              :row-per-page="{cols: 12, sm: 12, md: 4, lg: 4, xl: 4}"
                              :row-after-per-page="{cols: 12, sm: 12, md: 12, lg: 2, xl: 2}"

                              :fixed="true"

                              :search-label-horizontal="false"

                              :fullWidth="true"
                              noContainerPadding="true">

                <b-container slot="row-after-per-page" class="mw-100 p-0">
                  <b-row>
                    <b-col>
                      <b-button class="float-right mt-3 mt-md-0 mt-lg-0 mt-xl-0"
                                :disabled="!(startFilter && startHourFilter && vehicleSelected)"
                                @click="downloadCustomExcel()"
                                id="excel-button">Excel
                      </b-button>
                    </b-col>
                  </b-row>
                </b-container>
              </standard-table>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </b-card>

    <b-container v-if="!motivationSent">
      <access-motivation @motivationSent="motivationDone()" ref="myMotivation"/>
    </b-container>
  </b-container>
</template>

<script>
import Vue from 'vue'
import { DateTime } from 'luxon'
import { find, orderBy, cloneDeep } from 'lodash'
import { Italian } from 'flatpickr/dist/l10n/it.js'
import motivations from '@/plugins/motivations'
import logKeys from "@/plugins/log-keys";

export default {
  name: "ReportStop",
  mounted () {
    if (this.motivationSent) this.updateLinks()
    this.$root.$on('change-lang', () => {
      if (this.$el.isConnected && this.motivationSent) {
        this.fetchData()
        this.updateLinks()
      }
    })
    this.$root.$on('resize', () => {
      this.checkWindowWidth()
    })
  },
  data () {
    const genericDateConfig = {
      dateFormat: 'Y-m-d',
      mode: 'single',
      altFormat: 'D j M Y',
      altInput: true,
      locale: Italian,
      disable: [date => date > new Date()],
      defaultHour: 0
    }
    const genericTimeConfig = {
      dateFormat: 'H:i',
      altFormat: 'H:i',
      altInput: true,
      locale: Italian,
      noCalendar: true,
      enableTime: true,
      time_24hr: true,
      minTime: null,
      maxTime: null,
      defaultHour: 0,
      allowInput: true
    }
    const config = this.$route.meta.config

    return {
      config,
      DateTime,
      isMobile: false,
      searchValid: false,
      // motivation data
      motivationSent: false,
      //  main data
      maxReportRangeHour: 24,
      reportStops: [],
      reportStopsFields: [],
      reportDetails: {},
      reportMain: {},
      // filters
      originalVehicles: [],
      vehicleSelected: '',
      startFilterConfig: cloneDeep(genericDateConfig),
      startHourFilterConfig: cloneDeep(genericTimeConfig),
      startFilter: null,
      startHourFilter: null,
      hourRange: 24,
      links: [
        '/organization/registry_vehicles'
      ]
    }
  },
  methods: {
    clickedLink (link) {
      this.$router.push(link.href)
    },
    fetchData(vehicle) {
      this.getVehicles().then(() => {
        this.getItems(vehicle)
      })
    },
    getVehicles () {
      return Vue.myGet(this, '/vehicles', 'vehicles').then((vehicles) => {
        this.originalVehicles = [{ id: '', imei: true, plateNumber: vehicles && vehicles.length !== 0 ? this.$t('message.selectOption') : this.$t('message.noOption') }]
        const orderedItems = orderBy(vehicles, 'plateNumber')
        orderedItems.forEach((vehicle) => {
          this.originalVehicles.push(vehicle)
        })
        return vehicles
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    getVehicleOption (e) {
      return `${e.plateNumber}${e.type && e.type.brand ? ' - ' + e.type.brand : ''}${e.type && e.type.model ? ' - ' + e.type.model : ''}`
    },
    getItems(vehicle) {
      const vehicleSelected = vehicle || this.vehicleSelected
      const tsStart = this.parseDateAndHoursToMillis(this.startFilter, this.startHourFilter)
      const tsEnd = tsStart + (this.hourRange * 60 * 60 * 1000)
      let url = 'report'

      if (!vehicleSelected && vehicleSelected === '' || !tsStart || !tsEnd) return false

      url = `${url}?vehicle=${vehicleSelected}`
      url = `${url}&start=${tsStart / 1000}`
      url = `${url}&end=${tsEnd / 1000}`
      url = `${url}&format=json`

      this.$root.$emit('activeLoader', true)

      this.reportStops = []
      this.getReportStopsFields()
      this.searchValid = true

      return Vue.myGet(this, url, 'report').then(positions => {
        this.reportStops = positions.stopList
        this.reportDetails = positions.stats
        this.reportMain = {
          plateNumber: positions.plateNumber,
          start: positions.start,
          end: positions.end,
        }
        if (this.vehicleSelected && this.startFilter && this.startHourFilter) this.logData()
        this.$root.$emit('activeLoader', false)
        if (!positions.stopList || positions.stopList.length === 0) Vue.info(this, this.$tc('info.emptyPositions'))
        return true
      }).catch(error => {
        this.$root.$emit('activeLoader', false)
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    getReportStopsFields() {
      this.reportStopsFields = [
        { key: 'address', label: this.$tc('message.address', 1), sortable: true, sortDirection: 'desc'  },
        { key: 'driver', label: this.$tc('message.driver', 1), sortable: true, sortDirection: 'desc' },
        { key: 'startDate', label: this.$tc('message.start', 1), sortable: true, sortDirection: 'desc' },
        { key: 'duration', label: `${this.$tc('message.duration', 1)} ${this.$tc('message.stop', 1).toLocaleLowerCase()}` }
      ]
    },
    downloadCustomExcel () {
      const plateNumber = find(this.originalVehicles, o => o.id === this.vehicleSelected).plateNumber
      const fileName = `${plateNumber}`
      const start = this.reportMain.start
      const end = this.reportMain.end
      let colName = []

      const body = [
        [this.$tc('message.numberPlate', 1), plateNumber],
        [this.$tc('message.start', 1), start, '', this.$tc('message.end', 1), end],
      ]

      this.reportDetails.forEach(detail => {
        body.push([detail.key, detail.value])
      })

      body.push([])

      this.reportStopsFields.forEach(field => {
        colName.push(field.label)
      })
      body.push(colName)

      this.reportStops.forEach(position => {
        let raw = []
        this.reportStopsFields.forEach(field => {
          raw.push(position[field.key])
        })
        body.push(raw)
      })

      Vue.excelFromCustomMatrix(body, fileName)
    },
    parseDateAndHoursToMillis(day, hours) {
      const GMTZoneDiff = -1 * (new Date().getTimezoneOffset()*60*1000)
      let millis = 0

      if (day) {
        millis = new Date(day).getTime() - GMTZoneDiff
        if (hours) {
          let h = parseInt(hours.split(':')[0])*60*60*1000
          let minutes = parseInt(hours.split(':')[1])*60*1000
          millis = millis + h + minutes
        }
      }

      return millis
    },
    resetStart () {
      this.startFilter = null
      this.startHourFilter = null
    },
    resetStartHour () {
      this.startHourFilter = null
    },
    searchPositions () {
      let start = this.startFilter
      let startH = this.startHourFilter
      let vehicle = this.vehicleSelected

      if (!start || !startH || !vehicle) {
        this.reportStops = []
        this.reportDetails = {}
        this.reportMain = {}
        Vue.info(this, this.$tc('info.allFieldsInPositionReportRequired', 1))
        this.searchValid = false
        return false
      }
      this.getItems()
    },
    updateLinks () {
      const links = []
      this.links.forEach(link => {
        links.push({ href: link })
      })
      this.$root.$emit('change-links', links)
    },
    redirect (link) {
      if (link.href) this.$router.push(link.href)
    },
    checkWindowWidth () {
      const size = Vue.myGetWindowSize()
      this.isMobile = (size !== 'md' && size !== 'lg' && size !== 'xl')
    },
    //motivation methods
    motivationDone() {
      this.motivationSent = true
      this.$refs.myMotivation.reset()

      this.fetchData()

      Vue.success(this, `${this.$tc('message.motivation')} ${this.$tc('message.added', 2).toLowerCase()}`)
    },
    // log functions
    logData () {
      const vehicle = this.vehicleSelected
      const start = this.parseDateAndHoursToMillis(this.startFilter, this.startHourFilter)
      const end = start + (this.hourRange * 60 * 60 * 1000)
      const logObj = Vue.getLogObj(this, 'get', '/map')
      const format = 'dd-MM-yyyy HH:mm:ss'

      logObj.data.details = []

      if (start) logObj.data.details.push({text: 'message.start', option: 1, value: DateTime.fromMillis(start).toFormat(format)})
      if (end) logObj.data.details.push({text: 'message.end', option: 1, value: DateTime.fromMillis(end).toFormat(format)})
      if (vehicle) logObj.data.details.push({text: 'message.vehicle', option: 1, value: vehicle, key: logKeys.vehicle})

      Vue.myLogPost(logObj)
    }
  }
}
</script>
